import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import SourceAPI from '../../api/SourceAPI';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';

class SourceList extends React.Component {

  constructor(props) {
    super(props);
    this.sources = [];
    this.state = { ...this.state, source: { name: '' }, popup: false, inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).source;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) SourceAPI.list(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = sources => { this.sources = sources; this.setState({ inApiCall: false }); };

  show = i => {
    let source;
    if (i === -1) {
      source = { id: 0, name: '' };
    } else {
      source = { id: this.sources[i].id, name: this.sources[i].name };
    }
    this.setState({ ...this.state, source: source, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.source.name.trim().length === 0) return;

    this.setState({ ...this.state, popup: false, inApiCall: true });
    SourceAPI.save(this.state.source, this.success, this.onFail);
  };
  success = () => {
    Util.showNotification('Successful', 'Source successfully saved', 'success');
    this.props.onModuleChanged();
    SourceAPI.list(this.onReceived, this.onFail);
  };

  nameChange = val => this.setState({ ...this.state, source: { ...this.state.source, name: val } });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.sources[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        SourceAPI.delete(this.sources[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Source Deleted successfully', 'success');
    SourceAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const sourceUI = this.sources.map((source, _i) => (
      <tr key={`source_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{source.name}</td>
        <td>{Display.ModelLabelValue('user', source.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(source.created_date)}</td>
        <td>{Display.ModelLabelValue('user', source.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(source.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update</div>
          }
          {source.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete</div>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Source</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Source Name"
                    className="mr-sm-2"
                    value={this.state.source.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pb-3"><h3>Sources</h3></div>
              {this.Add &&
                <div className="col-md-8 text-right pb-3">
                  <span className="success buttons pcat" onClick={() => this.show(-1)}>
                    + Add Source</span>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {sourceUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(SourceList);
